<template>
  <!-- Mounted once in the dashboard layout so the panel and composer survive route changes -->
  <div>
    <ConversationFloatingPanel />
    <div v-if="composerOpen" class="composer-host" :class="{ 'is-beside-panel': conversationPanelVisible }">
      <NewMessagePanel :key="composerRecipient?.id ?? 'blank'" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue"
import ConversationFloatingPanel from "@/modules/patient-conversations/components/thread/ConversationFloatingPanel.vue"
import NewMessagePanel from "@/modules/patient-conversations/components/thread/NewMessagePanel.vue"
import { usePatientConversationPanel } from "@/modules/patient-conversations/composables/patient-conversation-panel"

const { composerOpen, composerRecipient, openConversationId, mode } = usePatientConversationPanel()

// A floating conversation keeps the bottom-right corner; the composer then sits to its left
const conversationPanelVisible = computed<boolean>(() => !!openConversationId.value && mode.value === "floating")
</script>

<style scoped lang="sass">
.composer-host
  position: fixed
  right: 20px
  bottom: 20px
  z-index: 1800

  &.is-beside-panel
    right: 460px
</style>
